import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { REDESIGN_COLORS } from '../../constants';

// The design draws the marker stroke slightly differently in headings than it
// does mid-paragraph: the inline one is flatter, tighter and less rotated.
// `light` is the translucent white stroke used on the amber closing card, where
// the amber marker would be invisible.
const GEOMETRY = {
    heading: { inset: '2%', bottom: '0.06em', height: '0.28em', rotate: '-1.5deg' },
    inline: { inset: '1.5%', bottom: '0.04em', height: '0.3em', rotate: '-0.8deg' },
    light: {
        inset: '2%',
        bottom: '0.06em',
        height: '0.26em',
        rotate: '-1.5deg',
        background: 'rgba(255, 255, 255, 0.75)',
    },
};

const useStyles = makeStyles(() => ({
    root: ({ variant, nowrap }) => {
        const g = GEOMETRY[variant] || GEOMETRY.heading;

        return {
            position: 'relative',
            // Creates the stacking context that keeps the marker stroke behind the
            // glyphs but still above the section background.
            zIndex: 0,
            whiteSpace: nowrap ? 'nowrap' : 'normal',
            '&::after': {
                content: '""',
                position: 'absolute',
                zIndex: -1,
                left: `-${g.inset}`,
                right: `-${g.inset}`,
                bottom: g.bottom,
                height: g.height,
                borderRadius: '40% 70% 35% 55%',
                background: g.background || REDESIGN_COLORS.highlight,
                transform: `rotate(${g.rotate})`,
            },
        };
    },
}));

/**
 * Wraps a word or phrase in the hand-drawn amber marker stroke the redesign
 * uses for emphasis. `heading` keeps the phrase on one line, as headings do in
 * the design; `inline` is for emphasis inside running text, and wraps.
 */
const HighlightMark = ({ variant = 'heading', nowrap = variant === 'heading', className, children }) => {
    const classes = useStyles({ variant, nowrap });

    return <span className={[classes.root, className].filter(Boolean).join(' ')}>{children}</span>;
};

export default HighlightMark;
